function* collectPlaceholderNames(node) {
  if ("type" in node) {
    switch (node.type) {
      case "paragraph":
        for (const child of node.content) {
          yield* collectPlaceholderNames(child);
        }
        break;
      case "placeholder":
        yield node.attrs.name;
        break;
      case "text":
      default:
        break;
    }
  } else if ("content" in node) {
    for (const child of node.content) {
      yield* collectPlaceholderNames(child);
    }
  }
}
function checkIncludesPlaceholderName(node, targetPlaceholderName) {
  for (const placeholderName of collectPlaceholderNames(node)) {
    if (placeholderName === targetPlaceholderName) {
      return true;
    }
  }
  return false;
}
function substituteVariablesInInlineContent(content, options) {
  return content.flatMap((child) => {
    if (child.type === "placeholder") {
      return options.substituteVariable(child.attrs.name);
    } else {
      return [child];
    }
  });
}
function substituteVariablesInParagraphNode(node, options) {
  return {
    type: "paragraph",
    content: substituteVariablesInInlineContent(node.content, options)
  };
}
function substituteVariablesInSingleLineContent(subject, options) {
  return {
    content: substituteVariablesInInlineContent(subject.content, options)
  };
}
function substituteVariablesInMultilineContent(body, options) {
  return {
    content: body.content.map(
      (node) => substituteVariablesInParagraphNode(node, options)
    )
  };
}
function createSubstituteVariableWithText(substituteVariable) {
  return (name) => {
    const text = substituteVariable(name);
    return text ? [{ type: "text", text }] : [];
  };
}
export {
  checkIncludesPlaceholderName,
  collectPlaceholderNames,
  createSubstituteVariableWithText,
  substituteVariablesInMultilineContent,
  substituteVariablesInSingleLineContent
};
//# sourceMappingURL=helpers.js.map
